import react from "react";
import './CardDashboard.scss'
import Text from "../../Atomsv2/Text/Text";
const CardDashboard = ({ title = "Titulo", icon = "info", iconColor,iconSize = '15px', children,footer,style }) => {
    return (
        <div className="CardDashboard" style={style}>
            <div className="title-container">
                <Text weight={"600"}>{title}</Text>
                <span className="icon" data-icon={icon} style={{ color: iconColor,fontSize:iconSize}} />
            </div>
            <div className="contentC-D">
                {children}
            </div>
            <div className="footerCardDashboard">
                {footer}
            </div>
        </div>
    )
}
export default CardDashboard